import type { BlockResult } from '@/types/blocker'
import type { Journey } from '@/types/journey'
import type { Progress } from '@/types/progress'

import type { JourneyUiStatus } from '../constants/status'

type JourneyWithProgress = Journey & {
  _progress: Progress
  active?: boolean
}

export const getJourneyUiStatus = (
  journey: JourneyWithProgress,
  blockResult: BlockResult
): JourneyUiStatus => {
  if (journey.active === false) {
    return 'expired'
  }

  if (!blockResult.unlocked) {
    return 'locked'
  }

  if (
    journey._progress.finished ||
    journey._progress.finishedPercent >= 1
  ) {
    return 'success'
  }

  if (journey._progress.finishedPercent > 0) {
    return 'progress'
  }

  return 'available'
}
